// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".the-select[data-v-0db4de68]{max-width:-moz-fit-content;max-width:fit-content}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
